import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import AUTHOR from "../data/author";
import UpsellCTA from "../components/UpsellCTA";

export default function About() {
    return (
        <>
            <Helmet><title>About — OpenCSV</title></Helmet>
            <section className="border-b border-black/10">
                <div className="mx-auto max-w-3xl px-4 md:px-8 py-20">
                    <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mb-4">/ about</div>
                    <h1 className="font-display font-black tracking-tighter text-5xl md:text-6xl">Why OpenCSV exists.</h1>
                    <div className="prose mt-8 text-ink-soft space-y-5 text-base leading-relaxed">
                        <p>Spreadsheets have gotten heavy. They want your time, your money, and your attention. OpenCSV is the opposite — a tool that opens, lets you edit, and gets out of your way.</p>
                        <p>We charge $1 once because building, fixing, and maintaining a real product takes hours that someone has to pay for. The dollar covers Stripe's cut, the servers, and a tiny slice of the time it takes to ship and support the app for years &mdash; not weeks.</p>
                        <p>It also acts as a soft filter. Bots and spammers don't bother paying a dollar; real users do, and that's who we build for.</p>
                        <p>OpenCSV runs in any browser on any device. The web app is the same product as our future iOS and Android apps — built by a tiny team that ships small, lovable software.</p>
                    </div>

                    <div className="mt-14 border border-black/10 bg-white p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start" data-testid="about-author">
                        <img src={AUTHOR.photo} alt={AUTHOR.name} className="w-32 h-32 rounded-full object-cover border border-black/10 shrink-0" />
                        <div>
                            <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted">/ founder</div>
                            <h2 className="font-display font-black tracking-tighter text-3xl mt-1">{AUTHOR.name}</h2>
                            <p className="text-sm text-ink-muted mt-1">{AUTHOR.role} · {AUTHOR.location}</p>
                            <p className="ui-heading text-xs uppercase tracking-widest text-cobalt mt-3">{AUTHOR.credentials}</p>
                            <p className="text-sm text-ink-soft mt-4 leading-relaxed">{AUTHOR.bio}</p>
                            <p className="text-sm text-ink-soft mt-4 leading-relaxed">Got a question, a bug, or just want to say hi? Email me directly at <a href="mailto:flyingfitz@gmail.com" className="underline text-cobalt">flyingfitz@gmail.com</a>.</p>
                        </div>
                    </div>

                    <div className="mt-12 grid md:grid-cols-3 gap-px border border-ink/10 bg-ink/10">
                        {[
                            ["100k+", "rows handled smoothly"],
                            ["<200ms", "average open time"],
                            ["$1", "lifetime, forever"],
                        ].map(([n, l]) => (
                            <div key={l} className="bg-white p-6">
                                <div className="font-display font-black text-3xl">{n}</div>
                                <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mt-1">{l}</div>
                            </div>
                        ))}
                    </div>

                    <div className="mt-12 text-center">
                        <UpsellCTA
                            className="btn-brutal inline-flex items-center bg-cobalt text-white px-6 py-3 ui-heading text-sm font-semibold border border-cobalt"
                            label="Try OpenCSV Pro free"
                            paidLabel="Open the editor"
                            data-testid="about-cta"
                        />
                    </div>
                </div>
            </section>
        </>
    );
}
